import colors from './lib/colors';

const breakpoints = ['40em', '52em', '64em'];

const IS_EDU_LAYOUT =
  localStorage.getItem('sse.isEduLayout') &&
  localStorage.getItem('sse.isEduLayout') === 'true';

const theme = {
  colors,
  breakpoints,
  layout: {
    edu: IS_EDU_LAYOUT || false,
  },
};

export default theme;

type Theme = typeof theme;
export interface AppTheme extends Theme { }
